import axiosInstance from '@/core/api'
import {
	GetLineMessageLogsRequest,
	GetLineMessageLogsResponse,
	GetLineMessageLogMessagesRequest,
	GetLineMessageLogMessagesResponse,
	GetLineMessageLogGroupedResponse,
	LineAutoMessageLogModel,
} from '../../types'

class LineMessageLogService {
	async getLineMessageLogs(
		params: GetLineMessageLogsRequest,
	): Promise<GetLineMessageLogsResponse> {
		const response = await axiosInstance.get<GetLineMessageLogsResponse>(
			'/admin/line-message-log',
			{ params },
		)
		return response.data
	}

	async getLineMessageLogById(logId: string): Promise<LineAutoMessageLogModel> {
		const response = await axiosInstance.get<LineAutoMessageLogModel>(
			`/admin/line-message-log/${logId}`,
		)
		return response.data
	}

	async getLineMessageLogMessages(
		logId: string,
		params: GetLineMessageLogMessagesRequest,
	): Promise<GetLineMessageLogMessagesResponse> {
		const response = await axiosInstance.get<GetLineMessageLogMessagesResponse>(
			`/admin/line-message-log/${logId}/messages`,
			{ params },
		)
		return response.data
	}

	async getLineMessageLogGrouped(
		logId: string,
	): Promise<GetLineMessageLogGroupedResponse> {
		const response = await axiosInstance.get<GetLineMessageLogGroupedResponse>(
			`/admin/line-message-log/${logId}/grouped`,
		)
		return response.data
	}
}

export default new LineMessageLogService()
